export default __webpack_public_path__ + "static/media/BandpassFilterImg.722dbd9a.jpg";